<ng-container *ngFor="let item of list; index as i">
  <article class="media" [ngSwitch]="item.MWG_UPC_NUM === ''">
    <!-- misc item -->
    <ng-container *ngSwitchCase="true">
      <div class="media-left">
        <figure class="image is-64x64 loading-background">
          <img src="{{ item.MWG_IMG_URL }}" alt="" />
        </figure>
      </div>
      <div class="media-content">
        <p class="title is-size-6" style="margin-bottom: 0.25rem">
          {{ item.MWG_PRODCT_NAME }}
        </p>
        <p class="has-text-grey">
          {{ item.MWG_ITEM_SIZE_DESC }}
        </p>
        <ng-container *ngIf="isOutOfStock">
          <p>You Ordered: {{ item.ORD_QTY }}</p>
          <p>We are Short: {{ item[qtyField] }}</p>
        </ng-container>
        <ng-container *ngIf="isSub">
          <p>Qty: {{ item.ORD_QTY }}</p>
        </ng-container>
      </div>
    </ng-container>
    <!-- regular item -->
    <ng-container *ngSwitchDefault>
      <div class="media-left">
        <figure class="image is-64x64 loading-background">
          <img src="{{ item.MWG_IMG_URL }}" alt="" />
        </figure>
      </div>
      <div class="media-content">
        <p class="title is-size-6" style="margin-bottom: 0.25rem">
          {{ item.MWG_BRND_NAME }}<br />
          {{ item.MWG_PRODCT_NAME }}
        </p>
        <p [ngSwitch]="item.ORD_WGHT_QTY > 0" class="has-text-grey">
          <ng-container *ngSwitchCase="true">
            {{ item.ORD_WGHT_QTY }} {{ item.MWG_ITEM_SIZE_DESC }} | ${{
              item.PRICE_PLUS_PRICE_AMT > 0 ? item.PRICE_PLUS_PRICE_AMT : item.MWG_UNIT_PRIC_AMT
            }}
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ item.MWG_ITEM_SIZE_DESC }} | ${{
              item.PRICE_PLUS_PRICE_AMT > 0 ? item.PRICE_PLUS_PRICE_AMT : item.MWG_ITM_PRIC_AMT
            }}
          </ng-container>
          <product-subs
            *ngIf="isPriceDeltaEnabled && subbedList !== undefined"
            itemPrice="{{ item.PRICE_PLUS_PRICE_AMT }} > 0 ? {{ item.PRICE_PLUS_PRICE_AMT }}: {{
              item.MWG_ITM_PRIC_AMT
            }}"
            subbedPrice="{{ subbedList[i].PRICE_PLUS_PRICE_AMT }} > 0 ? {{
              subbedList[i].PRICE_PLUS_PRICE_AMT
            }} : {{ subbedList[i].MWG_ITM_PRIC_AMT }}"
          ></product-subs>
        </p>
        <ng-container *ngIf="isOutOfStock">
          <p>You Ordered: {{ item.ORD_QTY }}</p>
          <p>We are Short: {{ item[qtyField] }}</p>
        </ng-container>
        <ng-container *ngIf="isSub">
          <p>Qty: {{ item.ORD_QTY }}</p>
        </ng-container>
      </div>
    </ng-container>
  </article>
</ng-container>
